module.exports = __webpack_public_path__ + "static/media/d8kz.c0bb8866.pdf";